/* Display labels only: never use these results as variant option values. */
(function () {
  'use strict';
  window.capkovSizeLabel = function (value) {
    if (typeof value !== 'string') return value;
    var labels = window.capkovSizeLabels || {};
    var phrases = [["adjustable_size", "Nastavitelná velikost", "Adjustable size"], ["universal", "Univerzální", "Universal"], ["adults", "Dospělí", "Adults"], ["all_ages", "Všechny věkové kategorie", "All ages"]];
    phrases.forEach(function (p) {
      var label = labels[p[0]];
      if (!label || /ranslation missing|capkov\.velikosti\./.test(label)) label = p[2];
      value = value.split(p[1]).join(label).split(p[2]).join(label);
    });
    var previous = '';
    return value.replace(/Jedna velikost|jedna velikost|One size|one size|One Size/g, 'CAPKOV_ONE_SIZE').split(' ').map(function (token) {
      var word = token.replace(/[),]/g, ''), lower = word.toLowerCase();
      var count = parseFloat(previous.replace(/\(/g, '').split(/[-–]/).pop()), key = '';
      if (token) previous = token;
      if (word === 'CAPKOV_ONE_SIZE') key = 'one_size';
      else if (count > 0) {
        if (/^(month|months|měsíc|měsíce|měsíců)$/.test(lower)) key = count === 1 ? 'month' : count <= 4 ? 'months_few' : 'months';
        if (/^(year|years|rok|roky|roků|let)$/.test(lower)) key = count === 1 ? 'year' : count <= 4 ? 'years_few' : 'years';
        if (/^(pair|pairs|pár|páry|párů)$/.test(lower)) key = count === 1 ? 'pair' : count <= 4 ? 'pairs_few' : 'pairs';
      }
      var label = labels[key];
      if (!label || /ranslation missing|capkov\.velikosti\./.test(label)) label = key === 'one_size' ? 'One size' : word;
      return key ? token.replace(word, function () { return label; }) : token;
    }).join(' ');
  };
  window.capkovOptLabel = function (v) {
    var size = window.capkovSizeLabel(v), colors = window.capkovOptL || {};
    return size !== v ? size : colors[v] || v;
  };
}());
